'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _Price = require('../Price');

var _Price2 = _interopRequireDefault(_Price);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Total = (_dec = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Total, _React$Component);

  function Total() {
    (0, _classCallCheck3.default)(this, Total);
    return (0, _possibleConstructorReturn3.default)(this, (Total.__proto__ || (0, _getPrototypeOf2.default)(Total)).apply(this, arguments));
  }

  (0, _createClass3.default)(Total, [{
    key: 'renderInformation',
    value: function renderInformation() {
      if (!this.props.information) {
        return '';
      }
      return _react2.default.createElement(
        'p',
        { styleName: 'm-total__label m-total__information', className: 't-text t-text--secondary' },
        this.props.information
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'clearfix' },
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { styleName: 'm-total__label', className: 't-h2' },
            this.props.title,
            _react2.default.createElement(
              'div',
              { styleName: 'painters-vat__label' },
              this.props.information
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'm-total__amount', className: 't-h4' },
            _react2.default.createElement(_Price2.default, { amount: this.props.amount, extraClass: 'a-bold-price' })
          )
        ),
        this.renderInformation()
      );
    }
  }]);
  return Total;
}(_react2.default.Component), _class2.propTypes = {
  amount: _react.PropTypes.string.isRequired,
  information: _react.PropTypes.string,
  title: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = Total;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/Adjustment/Total.js
// module id = 243
// module chunks = 0